module.exports = __webpack_public_path__ + "static/media/printer.c702db27.mjs";


//////////////////
// WEBPACK FOOTER
// ./node_modules/graphql/language/printer.mjs
// module id = 1352
// module chunks = 0